import { Routes, Route } from "react-router-dom";
import Login from "./components/Masterpanel/Auth/Login";
import Dashboard from "./components/Masterpanel/Dashboard/Dashboard";
import Clientlist from "./components/Masterpanel/Client/List";
import Clientform from "./components/Masterpanel/Client/Clientform";
import CmCategorylist from "./components/Masterpanel/Category/List";
import CmCategoryform from "./components/Masterpanel/Category/Categoryform";
import EmailBuilderlist from "./components/Masterpanel/EmailBuilder/List";
import EmailBuilderform from "./components/Masterpanel/EmailBuilder/Form";
import Whatsapptemplatelist from "./components/Masterpanel/Whatsapptemplate/List";
import Whatsapptemplateform from "./components/Masterpanel/Whatsapptemplate/Templateform";
import WhatsapptemplateView from "./components/Masterpanel/Whatsapptemplate/TemplateView";
import Availabilitylist from "./components/Masterpanel/Availability/List";
import AvailabilityForm from "./components/Masterpanel/Availability/Form";
import Staticblocklist from "./components/Masterpanel/Staticblock/List";
import Staticblockform from "./components/Masterpanel/Staticblock/Form";
import Emailtemplatelist from "./components/Masterpanel/Emailtemplate/List";
import Emailtemplateform from "./components/Masterpanel/Emailtemplate/Form";
import CmsPagelist from "./components/Masterpanel/CmsPage/List";
import CmsPageform from "./components/Masterpanel/CmsPage/Form";
import Commissionlist from "./components/Masterpanel/Commission/List";
import Commissionform from "./components/Masterpanel/Commission/Form";
import CommissionCreditHistory from "./components/Masterpanel/Commission/CreditHistory";
import CommissionDebitHistory from "./components/Masterpanel/Commission/DebitHistory";
import Holidaylist from "./components/Masterpanel/Holiday/List";
import Holidayform from "./components/Masterpanel/Holiday/Form";
import Missionform from "./components/Masterpanel/Mission/Form";
import MasterEngageV1Routes from "./MasterEngageV1Routes";
const MasterPanelRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login/>} />
      <Route exact path={`dashboard`} element={<Dashboard />} />
      <Route exact path={`client`} element={<Clientlist />} />
      <Route exact path={`client/add`} element={<Clientform />} />
      <Route exact path={`client/edit/:clientID`} element={<Clientform />} />
      <Route exact path={`category`} element={<CmCategorylist />} />
      <Route exact path={`category/add`} element={<CmCategoryform />} />
      <Route exact path={`category/edit/:categoryID`} element={<CmCategoryform />} />
      <Route exact path={`whatsapptemplate`} element={<Whatsapptemplatelist />} />
      <Route exact path={`whatsapptemplate/add`} element={<Whatsapptemplateform />} />
      <Route exact path={`whatsapptemplate/view/:templateID`} element={<WhatsapptemplateView />} />
      <Route exact path={`emailBuilder`} element={<EmailBuilderlist />} />
      <Route exact path={`emailBuilder/add`} element={<EmailBuilderform />} />
      <Route exact path={`emailBuilder/edit/:TemplateID`} element={<EmailBuilderform />} />
      <Route exact path={`availability`} element={<Availabilitylist />} />
      <Route exact path={`availability/add`} element={<AvailabilityForm />} />
      <Route exact path={`availability/edit/:EditID`} element={<AvailabilityForm />} />
      <Route exact path={`mission`} element={<Missionform />} />
      {/* <Route exact path={`pointssettings`} element={<Pointssettingsform />} /> */}
      <Route exact path={`staticblock`} element={<Staticblocklist />} />
      <Route exact path={`staticblock/add`} element={<Staticblockform />} />
      <Route exact path={`staticblock/edit/:EditID`} element={<Staticblockform />} />
      <Route exact path={`emailtemplate`} element={<Emailtemplatelist />} />
      <Route exact path={`emailtemplate/add`} element={<Emailtemplateform />} />
      <Route exact path={`emailtemplate/edit/:EditID`} element={<Emailtemplateform />} />
      <Route exact path={`cmspage`} element={<CmsPagelist />} />
      <Route exact path={`cmspage/add`} element={<CmsPageform />} />
      <Route exact path={`cmspage/edit/:EditID`} element={<CmsPageform />} />
      <Route exact path={`commission/credit-history/:EditID`} element={<CommissionCreditHistory />} />
      <Route exact path={`commission/credit-history`} element={<CommissionCreditHistory />} />
      <Route exact path={`commission/debit-history/:EditID`} element={<CommissionDebitHistory />} />
      <Route exact path={`commission/debit-history`} element={<CommissionDebitHistory />} />
      <Route exact path={`commission/adddebit/:EditID`} element={<Commissionform />} />
      <Route exact path={`commission/adddebit`} element={<Commissionform />} />
      <Route exact path={`commission`} element={<Commissionlist />} />
      <Route exact path={`holiday`} element={<Holidaylist />} />
      <Route exact path={`holiday/add`} element={<Holidayform />} />
      <Route exact path={`holiday/edit/:EditID`} element={<Holidayform />} />
      <Route exact path={`enagev1/*`} element={<MasterEngageV1Routes />} />
      
    </Routes>
  );
};

export default MasterPanelRoutes;
